import "./ProyectosCommon.css";
import { BasePageComponent } from "../../../shared/components/pages/BasePageComponent";
import { MacroeconomicoPanel } from "./MacroeconomicoPanel";
import { CosechasPanel } from "./CosechasPanel";
import { MacroProyectosParametrosPanel } from "./MacroProyectosParametrosPanel";

type Tab = "macroeconomico" | "cosechas" | "macro-proyectos";

/**
 * Une lo que antes eran dos páginas separadas (Macroeconómico y Cosechas) más un resumen nuevo de
 * Macro-Proyectos en una sola con pestañas, igual que PM_Parametros.html en los mockups: los tres
 * comparten el mismo tema -qué IPC aplica y cuándo queda congelado-, así que viven mejor juntos que
 * repartidos en el menú.
 */
export class ParametrosPage extends BasePageComponent {
  private _tab: Tab = "macroeconomico";
  private _macroPanel = new MacroeconomicoPanel();
  private _cosechaPanel = new CosechasPanel();
  private _macroProyectosPanel = new MacroProyectosParametrosPanel();
  private _cosechaRendered = false;
  private _macroProyectosRendered = false;

  public getAppRoute(): string { return "/proyectos/parametros"; }
  public getPageTitle(): string | null { return "Proyectos"; }

  protected override renderPageContent(pageContent: HTMLDivElement): void {
    pageContent.className = "sx-page pr-page";
    pageContent.innerHTML = `
      <div class="pr-content">
        <div class="pr-pg-hd">
          <div>
            <div class="pr-pg-ey">Proyectos · Configuración</div>
            <div class="pr-pg-ti">Parámetros</div>
            <div class="pr-pg-su">Qué IPC aplica hoy (SMMLV/IPC por año, tasa por cosecha) y cuándo queda congelado por Macro-Proyecto.</div>
          </div>
        </div>

        <div class="pr-tabs">
          <button class="pr-tab active" data-tab="macroeconomico">Macroeconómico</button>
          <button class="pr-tab" data-tab="cosechas">Cosechas</button>
          <button class="pr-tab" data-tab="macro-proyectos">Macro-Proyectos</button>
        </div>

        <div id="par-macro" class="pr-tab-panel"></div>
        <div id="par-cosechas" class="pr-tab-panel" hidden></div>
        <div id="par-macro-proyectos" class="pr-tab-panel" hidden></div>
      </div>
    `;

    pageContent.querySelectorAll<HTMLButtonElement>(".pr-tab").forEach((btn) => {
      btn.onclick = () => this._setTab(btn.dataset.tab as Tab);
    });

    this._macroPanel.render(pageContent.querySelector("#par-macro")!);
  }

  protected override beforeDispose(): void {}

  private _setTab(tab: Tab): void {
    if (tab === this._tab) return;
    this._tab = tab;

    this._pageContent.querySelectorAll<HTMLButtonElement>(".pr-tab").forEach((btn) => {
      btn.classList.toggle("active", btn.dataset.tab === tab);
    });
    this._pageContent.querySelector<HTMLElement>("#par-macro")!.hidden = tab !== "macroeconomico";
    this._pageContent.querySelector<HTMLElement>("#par-cosechas")!.hidden = tab !== "cosechas";
    this._pageContent.querySelector<HTMLElement>("#par-macro-proyectos")!.hidden = tab !== "macro-proyectos";

    // Cada panel se renderiza (y sincroniza datos) solo la primera vez que se ve su pestaña.
    if (tab === "cosechas" && !this._cosechaRendered) {
      this._cosechaPanel.render(this._pageContent.querySelector("#par-cosechas")!);
      this._cosechaRendered = true;
    }
    if (tab === "macro-proyectos" && !this._macroProyectosRendered) {
      this._macroProyectosPanel.render(this._pageContent.querySelector("#par-macro-proyectos")!);
      this._macroProyectosRendered = true;
    }
  }
}
